<mandate-hcard *ngIf="moduleType === 'projects' || !moduleType" [mandate]="action.mandate"
    class="cursor"></mandate-hcard>
<app-contact-card *ngIf="moduleType === 'mandates'" [contacts]="action.project?.contactsProjects"></app-contact-card>
<mat-card>
    <mat-card-content>
        <mat-list>
            <mat-list-item>
                <mat-icon matListIcon [ngClass]="(action.accepted && action.canceled) ? 'active' : 'hot'">
                    {{action.done ? (action.canceled ? GLOBAL.ICONS.CANCELED : (action.accepted ? 'thumb_up' : 'thumb_down')) :
                    'thumbs_up_down'}}
                </mat-icon>
                <h3 matLine> {{getSignTitle()}}
                    : {{action.priceDisplay ? action.priceDisplay : 'No Amount'}}
                </h3>
            </mat-list-item>
        </mat-list>
    </mat-card-content>
    <mat-card-content *ngIf="action.note">
        <p>{{action.note}}</p>
    </mat-card-content>
</mat-card>